import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock3Icon } from 'lucide-react';
const STORAGE_KEY = 'stretching_instructor_ready_countdown';
function getInitialTarget(): number {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  const parsed = stored ? Number.parseInt(stored, 10) : 0;
  if (parsed > Date.now()) return parsed;
  const target = Date.now() + 24 * 60 * 60 * 1000;
  window.localStorage.setItem(STORAGE_KEY, String(target));
  return target;
}
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(24 * 60 * 60 * 1000);
  useEffect(() => {
    let target = getInitialTarget();
    const tick = () => {
      if (target <= Date.now()) target = getInitialTarget();
      setRemaining(Math.max(0, target - Date.now()));
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }} className="mx-auto mt-12 max-w-3xl rounded-xl border border-accent/40 bg-surface p-6 text-center shadow-card sm:p-8" data-id="element-80" data-mp="1gxovut2owqid">
      <div className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-primary" data-id="element-81" data-mp="1zq9ihsrspzdq">
        <Clock3Icon size={18} className="text-accent" aria-hidden="true" data-id="element-82" data-mp="1l1wj0lti1yeh" /> The
        $27 USD offer ends in
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 sm:gap-4" data-id="element-83" data-mp="1pz55uzpleqm2">
        <TimeBox value={pad(hours)} label="h" data-id="element-84" data-mp="2dpiro8hl3t87" />
        <span className="font-display text-2xl text-accent" data-id="element-85" data-mp="2dopmvd26rdsp">:</span>
        <TimeBox value={pad(minutes)} label="min" data-id="element-86" data-mp="2ihsjju29f3d4" />
        <span className="font-display text-2xl text-accent" data-id="element-87" data-mp="2scr4teuge8mt">:</span>
        <TimeBox value={pad(seconds)} label="s" data-id="element-88" data-mp="2sc7og2kgbsaw" />
      </div>
      <p className="mt-6 text-sm font-semibold text-foreground" data-id="element-89" data-mp="2ndeiqwbep5la">
        Get the Complete System + All 5 Bonus Guides at the Current Price
      </p>
      <div className="mt-6 text-left" data-id="element-90" data-mp="2je5prto6xbqs">
        <div className="mb-2 flex justify-between gap-4 text-xs font-medium text-muted-foreground" data-id="element-91" data-mp="2edhnucyfbahs">
          <span data-id="element-92" data-mp="29eew1u7gf0rr">Current price access</span>
          <span className="font-semibold text-primary" data-id="element-93" data-mp="29fg9g5bxzzcn">
            Only a few spots left
          </span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-muted" data-id="element-94" data-mp="24l2a5ru5t82p">
          <div className="h-full w-[65%] rounded-full bg-primary" data-id="element-95" data-mp="1zov84a4vwgq1" />
        </div>
        <p className="mt-2 text-right text-xs text-muted-foreground" data-id="element-96" data-mp="1vni485lcqnlr">
          65% of spots already taken
        </p>
      </div>
    </motion.div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="min-w-[74px] rounded-lg border border-accent/50 bg-inverse px-3 py-3 sm:min-w-[100px]" data-id="element-97" data-mp="1lp2lor0e4mnv">
      <span className="font-display text-3xl font-semibold tabular-nums text-inverse-foreground sm:text-4xl" data-id="element-98" data-mp="18cnbwber16u">
        {value}
      </span>
      <span className="ml-1 text-xs font-semibold text-accent" data-id="element-99" data-mp="b3wkem1pk5x6">
        {label}
      </span>
    </div>;
}